export const Catagory = [
    {
        title: 'Consumer Electric:',
        p: {
            P1 : 'Air Conditioners |',
            link1 : "/shop" ,
            P2 : 'Audios & Theaters |',
            link2 : "/shop",
            P3 : 'Car Electronics |',
            link3 : "/shop",
            P4 : 'Office Electronics |',
            link4 : "/shop",
            P5 : 'TV Televisions',
            link5 : "/shop",
        }
    },{
        title: 'Clothing & Apparel:',
        p: {
            P1 : 'Man clothing |',
            link1 : "/shop" ,
            P2 : 'Woman clothing |',
            link2 : "/shop",
            P3 : 'Kids Zone |',
            link3 : "/shop",
            P4 : 'Baby Zone |',
            link4 : "/shop",
            P5 : 'Winter',
            link5 : "/shop",
        }
    },{
        title: 'Computer & Technologies:',
        p: {
            P1 : ' Laptop |',
            link1 : '/shop',
            P2 : 'Computer Components |',
            link2 : '/shop',
            P3 : ' Computer & Tablets |',
            link3 : '/shop',
            P4 : 'Gaming Laptop |',
            link4 : '/shop',
            P5 : 'Drive & Storages',
            link5 : '/shop',
        }
    }
]
